
'use strict';

var Backbone = require('backbone'),
  config = require('../../config'),
  utilities = require('../../utilities'),
  loginTemplate = require('../../../components/Login/templates/_LoginModal.hbs'),

  LoginView = Backbone.View.extend({

    className: 'LoginModal',

    render: function() {
      this.$el.html(loginTemplate({
        loginUrl: utilities.urlTemplate(config.urls.users.login, { url: window.location.href }),
        registerUrl: utilities.urlTemplate(config.urls.users.register, { url: window.location.href }),
        logoutUrl: config.urls.users.logout
      }));
      return this;
    }

  });

module.exports = LoginView;



// WEBPACK FOOTER //
// ./assets/js/session/views/LoginView.js